import Ruler from '../../src/legacy/Ruler.tsx';
export default Ruler;
